export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            关于谜妹
          </h2>
        </div>

        <div className="bg-background-100 rounded-2xl p-6 md:p-10 border border-background-200/60">
          <div className="flex flex-col md:flex-row items-start gap-6 md:gap-10">
            <div className="flex-shrink-0">
              <div className="w-20 h-20 md:w-24 md:h-24 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50 font-serif font-bold text-3xl md:text-4xl">
                谜
              </div>
            </div>
            <div className="flex-1">
              <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-900 mb-4">
                谜妹漫画
                <span className="block text-base md:text-lg font-normal text-foreground-500 mt-1">
                  韩漫日漫国漫分类大全
                </span>
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                谜妹漫画是一个专注于漫画资源聚合与分类阅读的在线平台，致力于为漫画爱好者提供
                高质量的韩漫、日漫和国漫阅读体验。平台涵盖悬疑漫画、恋爱漫画、搞笑漫画等
                20余个细分品类，收录超过30000部作品，所有内容均经过精心筛选与分类整理。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                我们采用下拉式无缝翻页阅读技术，无需跳转页面即可畅快追漫。每日同步更新
                热门连载，确保读者第一时间看到最新内容。无论是想追更热门的韩漫新作，
                回味经典的日漫神作，还是支持崛起的国漫原创，谜妹漫画都能满足你的阅读需求。
              </p>
              <div className="flex flex-wrap gap-3">
                {['全类型覆盖', '每日同步更新', '下拉流畅阅读', '免费海量资源', '多端适配'].map((tag) => (
                  <span key={tag} className="px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}